import React from 'react';
import ReactDOM from 'react-dom/client';
import 'mdb-react-ui-kit/dist/css/mdb.min.css' ;
// import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { modelObjectAdapters, modelStore, selectionStore } from './app/storage/model';
import { setupCommand } from './support/LocalCommand';
import { Dialog } from './support/modal_dialog';
import $ from "jquery"
import { preloadServer } from './app/storage/devSetup';
import { isDevMachine } from './support/general';
import { getBlockSelection } from './app/ux/EPagedSubscript';

const isFakeServer = false;

if (isFakeServer){
  preloadServer();
  setupCommand({
    ajaxUri : 'local',
    modelObjectAdapters : modelObjectAdapters,
    store : modelStore
  });
} else {
  setupCommand({
    ajaxUri : isDevMachine?"http://localhost:80/firstdraft_php/command.php":"/php/command.php",
    //ajaxUri : isDevMachine?"http://204.44.192.83/php/command.php":"/php/command.php",
    modelObjectAdapters : modelObjectAdapters,
    store : modelStore, 
  });
}






const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// window.addEventListener(`contextmenu`, (e) => e.preventDefault());

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

document.onselectionchange = event=>{
  var selection = getBlockSelection();
  var baseBlock = selection.blocks.length?selection.blocks[0]:null;;
  if ( baseBlock ) {
    selectionStore.dispatch(state=>{
      state.model.selectedBlockId = baseBlock.id;
    });
  }
};


